<div class="d-flex justify-content-center align-items-center loader-height">
  <mat-spinner [diameter]="30"></mat-spinner>
</div>
